import { useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../Button/Button";
import styles from "./BackButton.module.css";

export function BackButton({ fallbackTo }: { fallbackTo: string }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleClick = () => {
		if (window.history.length > 1) {
			window.history.back();
		} else {
			navigate({ to: fallbackTo });
		}
	};

	return (
		<Button variant="ghost" size="sm" onClick={handleClick} className={styles.button}>
			<ArrowLeft size={16} />
			{t("goBack")}
		</Button>
	);
}
